import { isImpersonationSessionActive } from '../../impersonation/utils/impersonationSession';

/** Set to true to show the banner and lock nav for unverified employees/managers. */
export const APP_EMAIL_VERIFICATION_ENFORCEMENT_ENABLED = false;

export const APP_EMAIL_VERIFICATION_STAFF_ROLES = new Set(['employee', 'manager']);
export const APP_EMAIL_VERIFICATION_ALLOWED_PATHS = [
  '/app/overview',
  '/app/overview/today',
  '/app/overview/pending',
  '/app/overview/updates',
];

export const APP_EMAIL_VERIFICATION_LOCK_TITLE = 'Verify your email to access';

export function isAppEmailVerificationRestrictedUser(user) {
  if (!APP_EMAIL_VERIFICATION_ENFORCEMENT_ENABLED) return false;
  if (!user?.uid) return false;  if (!APP_EMAIL_VERIFICATION_STAFF_ROLES.has(user?.role)) return false;
  if (user.emailVerified === true) return false;
  if (isImpersonationSessionActive()) return false;
  return true;
}

export function isAllowedPathWhileEmailUnverified(pathname = '') {
  return APP_EMAIL_VERIFICATION_ALLOWED_PATHS.includes(pathname);
}
